import { Lightbulb, ChevronRight } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNavigationStore } from '../../stores/navigationStore';

interface SuggestedPage {
  name: string;
  path: string;
  icon: React.ElementType;
  reason: string;
}

// Define suggested next steps based on current page
const suggestedPagesMap: Record<string, SuggestedPage[]> = {
  '/search': [
    { name: 'All Bookings', path: '/bookings', icon: () => <></>, reason: 'View all your bookings' },
    { name: 'Price Compare', path: '/price-comparison', icon: () => <></>, reason: 'Compare prices' },
  ],
  '/bookings': [
    { name: 'Queue Dashboard', path: '/automation/queues', icon: () => <></>, reason: 'Check queue status' },
    { name: 'Invoices', path: '/invoices', icon: () => <></>, reason: 'Create invoices' },
  ],
  '/customers': [
    { name: 'Companies', path: '/companies', icon: () => <></>, reason: 'View related companies' },
    { name: 'UCC', path: '/ucc', icon: () => <></>, reason: 'Communication history' },
  ],
  '/finance': [
    { name: 'Invoices', path: '/invoices', icon: () => <></>, reason: 'Manage invoices' },
    { name: 'Cash Flow', path: '/finance/cashflow', icon: () => <></>, reason: 'View cash flow' },
  ],
  '/ai-assistant': [
    { name: 'AI PNR Agent', path: '/ai/pnr-agent', icon: () => <></>, reason: 'Automated PNR processing' },
    { name: 'PNR Parser', path: '/ai/pnr-parser', icon: () => <></>, reason: 'Parse PNR data' },
  ],
};

export function NavigationSuggestedNext() {
  const location = useLocation();
  const navigate = useNavigate();
  const { density, incrementUsage } = useNavigationStore();

  const suggestedPages = suggestedPagesMap[location.pathname] || [];

  if (suggestedPages.length === 0) {
    return null;
  }

  const paddingClass = {
    compact: 'py-1.5 px-2',
    normal: 'py-2 px-3',
    comfortable: 'py-2.5 px-3',
  }[density];

  const spacingClass = {
    compact: 'space-y-0.5',
    normal: 'space-y-1',
    comfortable: 'space-y-1.5',
  }[density];

  return (
    <div className={`border-t border-gray-200 pt-3 mt-3 ${spacingClass}`}>
      <div className="px-3 py-2 flex items-center space-x-2">
        <Lightbulb className="w-3.5 h-3.5 text-yellow-500" />
        <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
          Suggested Next
        </span>
      </div>
      <div className={spacingClass}>
        {suggestedPages.map((page) => (
          <button
            key={page.path}
            onClick={() => {
              incrementUsage(page.path);
              navigate(page.path);
            }}
            className={`w-full flex items-center justify-between ${paddingClass} text-sm text-gray-700 hover:text-gray-900 hover:bg-yellow-50 rounded-lg transition group`}
          >
            <div className="flex-1 text-left">
              <div className="font-medium">{page.name}</div>
              <div className="text-xs text-gray-500">{page.reason}</div>
            </div>
            <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-gray-600" />
          </button>
        ))}
      </div>
    </div>
  );
}




























